import { SITE_CARE_MODES } from '../../constants/siteCareModes';

export const SITE_STATUS_FILTERS = [
  { id: 'all', label: 'Tous' },
  { id: 'active', label: 'Actifs' },
  { id: 'inactive', label: 'Inactifs' }
];

export const CARE_MODE_FILTER_ALL = 'all';

export const DEFAULT_SITE_LIST_FILTERS = {
  search: '',
  statusFilter: 'all',
  careModeFilter: CARE_MODE_FILTER_ALL
};

export const CARE_MODE_OPTIONS = [
  {
    value: SITE_CARE_MODES.DOCTOR_ONLY,
    label: 'Médecin seul',
    shortLabel: 'Médecin seul',
    description: 'Consultation médicale sans infirmière ni pharmacie locale.',
    icon: 'stethoscope',
    variant: 'doctor'
  },
  {
    value: SITE_CARE_MODES.DOCTOR_NURSE_NO_PHARMACY,
    label: 'Médecin + infirmière',
    shortLabel: 'Médecin + IDE',
    description: 'Prise en charge médicale et soins infirmiers, sans pharmacie sur site.',
    icon: 'users',
    variant: 'team'
  },
  {
    value: SITE_CARE_MODES.NURSE_ONLY_NO_PHARMACY,
    label: 'Infirmière seule',
    shortLabel: 'IDE seule',
    description: 'Soins infirmiers autonomes, sans médecin ni pharmacie locale.',
    icon: 'user',
    variant: 'nurse'
  },
  {
    value: SITE_CARE_MODES.WITH_PHARMACY,
    label: 'Avec pharmacie locale',
    shortLabel: 'Avec pharmacie',
    description: 'Dispensation possible sur le site (pharmacie locale activée).',
    icon: 'pills',
    variant: 'pharmacy'
  }
];

export function getCareModeMeta(value) {
  return CARE_MODE_OPTIONS.find((m) => m.value === value) || null;
}

export function getCareModeLabel(value) {
  return getCareModeMeta(value)?.label || value || '—';
}

export function isCentralSite(site) {
  return site && Number(site.is_central_pharmacy) === 1;
}

export function filterSites(sites, { search, statusFilter, careModeFilter }) {
  const q = (search || '').trim().toLowerCase();
  return (sites || []).filter((site) => {
    if (statusFilter === 'active' && !site.is_active) return false;
    if (statusFilter === 'inactive' && site.is_active) return false;
    if (careModeFilter !== CARE_MODE_FILTER_ALL && site.site_care_mode !== careModeFilter) {
      return false;
    }
    if (!q) return true;
    return (
      site.name?.toLowerCase().includes(q) ||
      site.address?.toLowerCase().includes(q) ||
      site.contact_person?.toLowerCase().includes(q) ||
      site.phone?.toLowerCase().includes(q) ||
      getCareModeLabel(site.site_care_mode).toLowerCase().includes(q)
    );
  });
}

export function hasSiteListFilters(filters) {
  return (
    Boolean(filters?.search?.trim()) ||
    filters?.statusFilter !== DEFAULT_SITE_LIST_FILTERS.statusFilter ||
    filters?.careModeFilter !== DEFAULT_SITE_LIST_FILTERS.careModeFilter
  );
}

export function buildSiteListStats(filteredSites, repositoryTotal, filters) {
  const total = filteredSites.length;
  const active = filteredSites.filter((s) => s.is_active).length;
  const inactive = total - active;
  const withPharmacy = filteredSites.filter(
    (s) => s.has_local_pharmacy || s.site_care_mode === SITE_CARE_MODES.WITH_PHARMACY
  ).length;
  const central = filteredSites.filter((s) => isCentralSite(s)).length;
  const activePct = total > 0 ? Math.round((active / total) * 100) : 0;
  const isFiltered = hasSiteListFilters(filters);

  return {
    total,
    active,
    inactive,
    withPharmacy,
    central,
    activePct,
    repositoryTotal,
    isFiltered
  };
}

export const EMPTY_SITE_FORM = {
  name: '',
  address: '',
  contact_person: '',
  phone: '',
  site_care_mode: SITE_CARE_MODES.DOCTOR_NURSE_NO_PHARMACY,
  has_local_pharmacy: false,
  has_duty_cabinet: false
};

export function siteFormFromRecord(site) {
  return {
    name: site.name || '',
    address: site.address || '',
    contact_person: site.contact_person || '',
    phone: site.phone || '',
    site_care_mode: site.site_care_mode || SITE_CARE_MODES.DOCTOR_NURSE_NO_PHARMACY,
    has_local_pharmacy:
      site.has_local_pharmacy !== undefined
        ? Boolean(site.has_local_pharmacy)
        : site.site_care_mode === SITE_CARE_MODES.WITH_PHARMACY,
    has_duty_cabinet: Boolean(site.has_duty_cabinet)
  };
}

export function buildSitePayload(formData) {
  const mode = formData.site_care_mode;
  return {
    ...formData,
    has_local_pharmacy: mode === SITE_CARE_MODES.WITH_PHARMACY ? true : Boolean(formData.has_local_pharmacy),
    has_duty_cabinet: Boolean(formData.has_duty_cabinet)
  };
}
